const ideas = [
  { title: 'Лендинг', hint: 'страница продукта с формой заявки' },
  { title: 'Дашборд', hint: 'таблицы и графики из базы' },
  { title: 'Магазин', hint: 'каталог, корзина и заказ' },
];

export function HomePage() {
  return (
    <div className="flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-2xl space-y-8">
        <div className="rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 leading-relaxed dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300">
          <span className="font-medium text-slate-900 dark:text-slate-100">Подсказка.</span>{' '}
          Пока агент редактирует код, эта страница обновляется автоматически —
          ничего перезагружать не нужно.
        </div>

        <div className="space-y-3">
          <div className="text-xs font-medium text-slate-500 uppercase tracking-wider dark:text-slate-400">
            Попробуйте попросить
          </div>
          <div className="grid sm:grid-cols-3 gap-3">
            {ideas.map((idea) => (
              <div
                key={idea.title}
                className="rounded-lg border border-slate-200 bg-white px-4 py-3 dark:border-slate-800 dark:bg-slate-900"
              >
                <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">{idea.title}</div>
                <div className="text-xs text-slate-500 mt-1 leading-relaxed dark:text-slate-400">
                  {idea.hint}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
